import { render, staticRenderFns } from "./CarItem.vue?vue&type=template&id=f5ff6400&scoped=true&"
import script from "./CarItem.vue?vue&type=script&lang=js&"
export * from "./CarItem.vue?vue&type=script&lang=js&"
import style0 from "./CarItem.vue?vue&type=style&index=0&id=f5ff6400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ff6400",
  null
  
)

export default component.exports